import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDClientDebt(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdClientDebt(period),
    queryFn: () => dashboardApi.getMDClientDebt(period),
  });
}
